import { Suspense, lazy } from 'react';
import DesktopHero from './DesktopHero';
import DesktopQuickLinks from './DesktopQuickLinks';
import DesktopAbout from './DesktopAbout';
import DesktopGiftCard from './DesktopGiftCard';
import BroadcastCarousel from '@/components/BroadcastCarousel';
import useHomeLayout from '@/lib/useHomeLayout';

const InstagramCarousel = lazy(() => import('@/components/InstagramCarousel'));

export default function DesktopHome({ hero, broadcasts, onBroadcastClick, allScreens = false }) {
  const { theme, sections } = useHomeLayout();

  const render = ({ type, settings: s }) => {
    switch (type) {
      case 'hero': return <DesktopHero hero={hero} s={s} theme={theme} />;
      case 'quick_links': return <DesktopQuickLinks s={s} theme={theme} />;
      case 'about': return <DesktopAbout s={s} theme={theme} />;
      case 'gift_card': return <DesktopGiftCard s={s} theme={theme} />;
      case 'news':
        if (!broadcasts?.length) return null;
        return (
          <section className="pt-4 pb-4" style={{ background: s.bg_color, fontFamily: theme.body_font }}>
            <div className="w-full px-4 md:px-8 lg:px-12">
              <div className="mb-8 text-center">
                <h2 className="font-script text-5xl lg:text-6xl" style={{ color: s.text_color || theme.accent_color }}>{s.title}</h2>
                {s.subtitle && <p className="text-sm font-medium tracking-wide mt-1" style={{ color: s.text_color || theme.primary_color }}>{s.subtitle}</p>}
              </div>
              <BroadcastCarousel broadcasts={broadcasts} onBroadcastClick={onBroadcastClick} />
            </div>
          </section>
        );
      case 'instagram':
        return <Suspense fallback={null}><InstagramCarousel title={s.title} subtitle={s.subtitle} textColor={s.text_color} /></Suspense>;
      default: return null;
    }
  };

  return (
    <div className={allScreens ? 'block' : 'hidden lg:block'}>
      {sections.filter((sec) => sec.visible !== false).map((sec) => <div key={sec.id}>{render(sec)}</div>)}
    </div>
  );
}